import { PolicyCheck } from '@/features/auth/authorization';

export const MaintenancePolicies: Record<string, PolicyCheck> = {
  'equipment.maintenance.view': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.view;
  },
  'equipment.maintenance.schedules.view': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.schedules.view;
  },
  'equipment.maintenance.schedules.create': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.schedules.create;
  },
  'equipment.maintenance.schedules.update': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.schedules.edit;
  },
  'equipment.maintenance.schedules.delete': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.schedules.delete;
  },
  'equipment.maintenance.schedules.complete': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.schedules.complete;
  },
  'equipment.maintenance.inspections.view': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.inspections.view;
  },
  'equipment.maintenance.inspections.create': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.inspections.create;
  },
  'equipment.maintenance.inspections.update': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.inspections.edit;
  },
  'equipment.maintenance.inspections.delete': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.inspections.delete;
  },
  'equipment.maintenance.inspections.complete': ({ acl, user, meta }) => {
    return acl.equipment.maintenance.inspections.complete;
  },
};
